import React, { useEffect, useRef, useState } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import DataSelfie from "components/DataSelfie";
import DataSelfieLegend from "components/DataSelfieLegend";
import { DataStore } from "@aws-amplify/datastore";
import { EyepieceThreeResponse, Users } from "models";
import { Auth } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
  },
}));
function EyepieceThreeResult() {
  const classes = useStyles();

  const respCanvasEl = useRef(null);
  const [myResponse, setMyResponse] = useState();
  const [schoolResponses, setSchoolResponses] = useState();
  // const [selectedResponse, setSelectedResponse] = useState();
  const [school, setSchool] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [allSchools, setAllSchools] = useState([]);
  useEffect(async () => {
    // My response
    const user = await Auth.currentAuthenticatedUser();

    const groups = user.signInUserSession.accessToken.payload["cognito:groups"];
    // console.log("ADMIN", groups, groups.indexOf("Admin") !== -1);
    if (groups){
      setIsAdmin(groups.indexOf("Admin") !== -1);
    }
    // School responses
    let allUsers = await DataStore.query(Users);

    const me = allUsers.find((d) => d.email === user.attributes.email);
    const school = me.school;
    setSchool(school);

    const allSchools = Array.from(new Set(allUsers.map((d) => d.school)));
    setAllSchools(allSchools);

    initialize(school);
  }, []);
  async function initialize(school) {
    const user = await Auth.currentAuthenticatedUser();
    const responses = await DataStore.query(EyepieceThreeResponse, (r) =>
      r.school("eq", school).username("eq", user.username)
    );
    console.log("my response", responses, school, user);
    if (responses.length > 0) {
      const myResponse = JSON.parse(responses[0].questions);

      setMyResponse(myResponse);
      // setSelectedResponse(myResponse);
    } else {
      setMyResponse(null);
    }
    const schoolResponses = await DataStore.query(EyepieceThreeResponse, (r) =>
      r.school("eq", school).username("ne", user.username)
    );
    console.log("other responses ", schoolResponses, school, user);
    if (schoolResponses.length > 0) {
      const scr = schoolResponses.map((resp) => JSON.parse(resp.questions));
      // console.log("schools", scr);
      setSchoolResponses(scr);
    } else {
      setSchoolResponses(null);
    }
  }
  function handleSchoolChange(event) {
    console.log("school", event.target.value);
    setSchool(event.target.value);
    initialize(event.target.value);
  }
  return (
    <Container>
      {isAdmin && (
        <Box pb={2}>
          <FormControl className={classes.formControl} margin="normal">
            <InputLabel id="select-school">School</InputLabel>
            <Select
              labelId="select-school"
              id="school-select"
              value={school}
              onChange={handleSchoolChange}
            >
              {allSchools.map((school) => (
                <MenuItem key={school} value={school}>
                  {school}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Grid container >
            {myResponse && (
              <Grid item xs={4}>
                <DataSelfie response={myResponse} school={school} self={true} width={225} height={225}/>
              </Grid>
            )}
            {schoolResponses &&
              schoolResponses.map((resp, i) => (
                <Grid key={i} item xs={4}>
                  <DataSelfie response={resp} school={school} width={225} height={225}/>
                </Grid>
              ))}
          </Grid>
        </Grid>
        <Grid item xs={4}>
        <Typography variant="h5" gutterBottom>
          Legend
        </Typography>
        <DataSelfieLegend  layout="column"/>
        </Grid>
      </Grid>
      {/* <Box mt={5}>
        <Typography variant="h5" gutterBottom>
          Legend
        </Typography>
        <DataSelfieLegend />
      </Box> */}
    </Container>
  );
}

export default EyepieceThreeResult;
